import { injectable } from 'inversify';
import LoggerService from './LoggerService';
import DITYPES from '../config/di.types';
import DIContainer from '../config/di.container';
import { IGlobalErrorHandlerService } from './interfaces';
import { unknownError, serverDownError, unauthorizedError, notFoundError, failedToProcessError, forbiddenError } 
from '../common/constant';
import NotificationService from './NotificationService';
import { EErrorType } from "../common/enum/EErrorType";
import { useHistory } from 'react-router';
import { EComponentName } from '../common/enum/EComponentName';

@injectable()
export default class GlobalErrorHandlerService implements IGlobalErrorHandlerService {
    loggerService: LoggerService;
    notificationService : NotificationService;
    constructor() {
      this.loggerService = DIContainer.get<LoggerService>(DITYPES.LoggerService);
      this.notificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
    }

      handleError = (error : any, event : any) => {        
        let errMessage : string = '';
          errMessage = unknownError;
        try {
          this.loggerService.info('ErrorHandler : handleError()');

          if (event != null) { // an exception throw from a Promise function
              errMessage = event.reason.message;
          } else if (error != null) { // handle exceptions thrown from React components or API
              errMessage = error.message;
              let status = error.response ? error.response.status : undefined;
              if(error.response === undefined) {
                status = error.request ? error.request.status : undefined;
              }
              if (status === 0) {
                errMessage = serverDownError;
              }
              else if (status === 401) {
                errMessage = unauthorizedError;
              }
              else if (status === 403) {                
                this.notificationService.notifyToster(forbiddenError,EErrorType.ERROR);
                window.location.href = "/Home/SignOut"
              }
              else if (status === 404) {
                errMessage = notFoundError;
              }
              else if (status === 500) {                
                errMessage = failedToProcessError;
              }
              else if (status === 400) {
                errMessage = error.response.data[0].ErrorMessage;
              }
          }
          //Enable below line when we setup the NLog
          //this.loggerService.error(errMessage);
          this.notificationService.notifySnackbar(errMessage, this.getCurrentComponentName());
          window.scrollTo(0, 0);
        } catch (err) {
          // //Enable below line when we setup the NLog
          //this.loggerService.error(err.message);
          this.notificationService.notifyToster(errMessage,EErrorType.ERROR );
        }
      }     

      getCurrentComponentName() : EComponentName {
        const eComponentName = Object.keys(EComponentName).filter((item) => {
          return isNaN(Number(item));
        });   
    
        var enumString = eComponentName.find(v => window.location.href.includes(v));
        if (enumString) {
          return EComponentName[enumString];
        }
        else{
          return EComponentName.NotMentioned
        }   
      }
}
